"use client";

import { useRef } from "react";
import { useServerInsertedHTML } from "next/navigation";

// Inline scripts that must run before first paint (they only toggle classes on
// <html>). They're written into the server HTML's <head> via
// useServerInsertedHTML instead of being rendered as <script> elements, so
// React never creates them on the client — where they can't execute anyway and
// React warns "Encountered a script tag…" whenever it client-renders the root
// (e.g. Next's 404 error shell). The hook is a no-op in the browser.
export default function BootScripts({ scripts }) {
  const inserted = useRef(false);

  useServerInsertedHTML(() => {
    // Called on every stream flush — emit only once per request.
    if (inserted.current) return null;
    inserted.current = true;
    return scripts.map((code, i) => <script key={i} dangerouslySetInnerHTML={{ __html: code }} />);
  });

  return null;
}
